import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UInputModule } from '../components/u-input/u-input.module';

const comps = [];

@NgModule({
  declarations: comps,
  imports: [CommonModule, UInputModule],
  exports: comps,
})
export class InfraComponentsSharedModule {}
